// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const campaignItemSchema = z.object({
  "id": z.string().uuid(),
  "tenant_id": z.string().uuid(),
  "campaign_id": z.string().uuid(),
  "user_id": z.string().uuid(),
  "application_id": z.string().uuid(),
  "grant_source": z.enum(["direct", "group", "both"]),
  "group_id": z.string().uuid().nullable().optional(),
  "group_name": z.string().optional(),
  "days_idle_snapshot": z.number().int(),
  "last_used_snapshot": z.string().datetime({ offset: true }).nullable().optional(),
  "user_email_snapshot": z.string(),
  "application_name_snapshot": z.string(),
  "reviewer_admin_id": z.string().uuid().nullable().optional(),
  "decision": z.enum(["pending", "approved", "revoked", "unknown", "needs_clarification", "resolved_external"]),
  "decided_at": z.string().datetime({ offset: true }).nullable().optional(),
  "decided_by": z.string().uuid().nullable().optional(),
  "decision_comment": z.string().optional(),
  "created_at": z.string().datetime({ offset: true }),
  "removal_completed_at": z.string().datetime({ offset: true }).nullable().optional(),
  "decision_history": z.array(z.object({
    "decision": z.enum(["pending", "approved", "revoked", "unknown", "needs_clarification", "resolved_external"]),
    "decided_at": z.string().datetime({ offset: true }).nullable(),
    "decided_by": z.string().uuid().nullable(),
    "comment": z.string().nullable()
  }))
});

export const campaignItemListSchema = z.object({
  "data": z.array(campaignItemSchema)
});

export const certificationCloseConflictSchema = z.object({
  "code": z.enum(["campaign-unresolved"]),
  "blockers": z.array(z.object({
    "item_id": z.string().uuid(),
    "reason": z.enum(["clarification", "group_access"])
  }))
});
